import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useLayoutEffect, useRef } from 'react';
import { AllPosts } from '@buildwise/libs/feed';
import LongAddPostButton from './LongAddPostButton';
import { HomeModuleFeatures, useBuildWiseModules } from '@buildwise/libs/helpers';
import { theme } from 'config/theme';

function PostsCenter() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const prevScrollPos = useRef<number>(window.scrollY);
  const { homeModule } = useBuildWiseModules();

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos, buttonRef]);

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.scrollY;
    // Find posts filters container element
    const postsFiltersRef = containerRef.current?.querySelector(
      '#posts-filter-container',
    ) as HTMLDivElement | null;

    if (currentScrollPos > prevScrollPos.current) {
      // Scrolling down
      if (buttonRef.current) {
        buttonRef.current.style.position = 'static';
        if (postsFiltersRef) {
          postsFiltersRef.style.top = '80px';
        }
      }
    } else {
      // Scrolling up
      if (buttonRef.current) {
        buttonRef.current.style.position = 'sticky';
        if (postsFiltersRef) {
          postsFiltersRef.style.top = '160px';
        }
      }
    }

    if (currentScrollPos === 0) {
      if (buttonRef.current) {
        buttonRef.current.style.position = 'static';
        if (postsFiltersRef) {
          postsFiltersRef.style.top = '80px';
        }
      }
    }

    prevScrollPos.current = currentScrollPos;
  }, [prevScrollPos, buttonRef, containerRef]);

  return (
    <Box ref={containerRef}>
      {homeModule?.otherAttributes?.['subTitle'] && (
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                color: theme.palette.custom.mistBlue,
                fontWeight: 700,
              }}
            >
              {homeModule.otherAttributes['subTitle']}
            </Box>
          </Grid>
        </Grid>
      )}
      <StickyContainer ref={buttonRef} sx={{ top: 80 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LongAddPostButton
              getActions={({ actions }) =>
                actions.filter(
                  (action) => action.name !== HomeModuleFeatures.SUMMARIZE_FORM_WITH_AI,
                )
              }
            />
          </Grid>
        </Grid>
      </StickyContainer>
      <AllPosts inlineFilters scrollInfoKey="all-posts" />
    </Box>
  );
}

const StickyContainer = styled(Box, { label: 'StickyContainer' })(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.custom.background,
  zIndex: 1,
  width: '100%',
  padding: '16px 0 4px',
  position: 'static',
}));

export default PostsCenter;
